import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import api from '../../../api/axios';
import { IApiResponseError, IApiState } from '../../../types/api';

interface ICheckIfUserEmailExistsRequest {
  email: string;
}

interface ICheckIfUserEmailExistsResponse {
  status?: boolean;
  message?: string;
  data?: {
    exists?: boolean;
  };
  errors?: IApiResponseError[];
}

const initialState: IApiState<ICheckIfUserEmailExistsResponse> = {
  value: null,
  status: 'idle',
  error: '',
};

export const checkIfUserEmailExistsAsync = createAsyncThunk(
  'userEmailExists/email',
  async (values: ICheckIfUserEmailExistsRequest, { rejectWithValue }) => {
    try {
      const { data } = await api.get<ICheckIfUserEmailExistsResponse>(
        `/user/email/${values.email}/exists`
      );

      return data;
    } catch (err) {
      const error = err as AxiosError<ICheckIfUserEmailExistsResponse>;

      return rejectWithValue(error.response?.data);
    }
  }
);

export const userExistsCheckSlice = createSlice({
  name: 'userEmailExists/email',
  initialState,
  reducers: {
    resetCheckExistingUser(state) {
      state.value = null;
      state.status = 'idle';
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(checkIfUserEmailExistsAsync.pending, (state) => {
        state.status = 'loading';
        state.error = '';
      })
      .addCase(checkIfUserEmailExistsAsync.fulfilled, (state, action) => {
        state.status = 'success';
        state.value = action.payload as ICheckIfUserEmailExistsResponse;
      })
      .addCase(checkIfUserEmailExistsAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.value = action.payload as ICheckIfUserEmailExistsResponse;
        state.error = action.error.message;
      });
  },
});

export const { resetCheckExistingUser } = userExistsCheckSlice.actions;

export default userExistsCheckSlice.reducer;
